/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ModelsTag,
  OpenUpEmployeesParams,
  ResponsePsychologistResponse,
  ResponseUserResponsePaginated,
  SetPsychologistThemesPayload,
  SetUserTagsPayload,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class PsychologistManagement<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags PsychologistManagement
   * @name GetUserTags
   * @summary Allow a managing psychologist to get a user's tags (Auth policies: HostOrSupportOrExpertPolicy)
   * @request GET:/api/v1/psychologist-management/{userId}/{tagType}
   * @secure
   * @response `200` `(ModelsTag)[]` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getUserTags = (userId: string, tagType: string, params: RequestParams = {}) =>
    this.http.request<ModelsTag[], void>({
      path: `/api/v1/psychologist-management/${userId}/${tagType}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PsychologistManagement
   * @name MakeClientAPsychologist
   * @summary Allow a managing psychologist to to give application users the role psychologist (Auth policies: SupportOrManagingPsychologistPolicy)
   * @request PUT:/api/v1/psychologist-management/make-psychologist/{userId}
   * @secure
   * @response `200` `ResponsePsychologistResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  makeClientAPsychologist = (userId: string, params: RequestParams = {}) =>
    this.http.request<ResponsePsychologistResponse, void>({
      path: `/api/v1/psychologist-management/make-psychologist/${userId}`,
      method: "PUT",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PsychologistManagement
   * @name OpenUpEmployees
   * @summary Allow psychologists to get a list of OpenUp employees, filtered by email domain (Auth policies: SupportOrManagingPsychologistPolicy)
   * @request GET:/api/v1/psychologist-management/openup-employees
   * @secure
   * @response `200` `ResponseUserResponsePaginated` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  openUpEmployees = (
    query: OpenUpEmployeesParams,
    params: RequestParams = {},
  ) =>
    this.http.request<ResponseUserResponsePaginated, void>({
      path: `/api/v1/psychologist-management/openup-employees`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PsychologistManagement
   * @name ReassignPsychologist
   * @summary Reassign the psychologist of a given consult (Auth policies: HostOrManagingPsychologistPolicy)
   * @request PUT:/api/v1/psychologist-management/reassign-psychologist/{userId}/{consultId}
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  reassignPsychologist = (
    userId: string,
    consultId: number,
    params: RequestParams = {},
  ) =>
    this.http.request<void, void>({
      path: `/api/v1/psychologist-management/reassign-psychologist/${userId}/${consultId}`,
      method: "PUT",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags PsychologistManagement
   * @name SetPsychologistThemes
   * @summary Allow a managing psychologist to set the themes for a psychologist (Auth policies: SupportOrManagingPsychologistPolicy)
   * @request POST:/api/v1/psychologist-management/set-psychologist-themes/{userId}
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  setPsychologistThemes = (
    userId: string,
    data: SetPsychologistThemesPayload,
    params: RequestParams = {},
  ) =>
    this.http.request<void, void>({
      path: `/api/v1/psychologist-management/set-psychologist-themes/${userId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags PsychologistManagement
   * @name SetUserTags
   * @summary Allow a managing psychologist to assign tags to a user (Auth policies: SupportOrManagingPsychologistPolicy)
   * @request POST:/api/v1/psychologist-management/{userId}/{tagType}
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  setUserTags = (
    userId: string,
    tagType: string,
    data: SetUserTagsPayload,
    params: RequestParams = {},
  ) =>
    this.http.request<void, void>({
      path: `/api/v1/psychologist-management/${userId}/${tagType}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}
